import {
  Button,
  type ButtonProps,
  Flex,
  List,
  NavigateBeforeRoundedIcon,
  styled,
  Text,
} from '@shared/components';
import { useMemo } from 'react';

import { UserMenuItem } from '../../components';
import { useSidebar } from '../../providers';
import { BackToPortalMenuItem } from '../back-to-portal-menu-item';
import { LogoutMenuItem } from '../logout-menu-item';

const BottomMenu = styled(Flex)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  flexDirection: 'column',
  marginTop: 'auto',
  borderTop: '1px solid',
  borderColor: theme.palette.grey[300],
  backgroundColor: 'white',
  width: '100%',
}));

const ToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'open',
})<ButtonProps & { open: boolean }>(({ open, theme }) => ({
  borderRadius: theme.shape.rounded(8),
  minWidth: 0,
  '.MuiSvgIcon-root': {
    transform: open ? '' : 'rotate(0.5turn)',
    transition: 'all 400ms ease-in-out',
  },
  margin: 16,
}));

export default function SidebarBottomMenu() {
  const { isOpen, toggle, user } = useSidebar();

  const isMinified = useMemo(() => !isOpen, [isOpen]);

  return (
    <BottomMenu>
      <List>
        <UserMenuItem displayName={user?.displayName} minified={isMinified} />
        <BackToPortalMenuItem minified={isMinified} />
        <LogoutMenuItem minified={isMinified} />
      </List>
      <ToggleButton
        variant='outlined'
        color='secondary'
        className='toggle-sidebar'
        startIcon={<NavigateBeforeRoundedIcon />}
        open={isOpen}
        onClick={toggle}
      >
        {isOpen ? <Text variant='body2'>ซ่อนเมนู</Text> : null}
      </ToggleButton>
    </BottomMenu>
  );
}
